import { Component } from '@angular/core';

@Component({
    selector: 'app-towns',
    templateUrl: './towns.component.html',
    styleUrls: ['./towns.component.scss'],
    standalone: false
})
export class TownsComponent {}
